{
  "enums": {
    "claimStatus": {
      "draft": "下書き",
      "submitted": "提出済み",
      "accepted": "受理済み",
      "denied": "却下",
      "paid": "支払済み"
    },
    "chargeStatus": {
      "pending": "保留中",
      "unbilled": "未請求",
      "posted": "計上済み",
      "billed": "請求済み",
      "adjusted": "調整済み",
      "voided": "無効"
    },
    "statementDelivery": {
      "print": "印刷",
      "email": "メール",
      "both": "印刷とメール",
      "mail": "郵送"
    },
    "statementStatus": {
      "generated": "生成済み",
      "sent": "送信済み",
      "viewed": "閲覧済み"
    },
    "denialStatus": {
      "new": "新規",
      "inReview": "審査中",
      "appealing": "不服申立中",
      "resolved": "解決済み",
      "writtenOff": "貸倒処理済み"
    },
    "denialPriority": {
      "low": "低",
      "medium": "中",
      "high": "高"
    },
    "claimType": {
      "professional": "医師",
      "institutional": "施設",
      "dental": "歯科",
      "pharmacy": "薬局"
    },
    "paymentMethod": {
      "cash": "現金",
      "check": "小切手",
      "creditCard": "クレジットカード",
      "debitCard": "デビットカード",
      "bankTransfer": "銀行振込",
      "digitalWallet": "電子ウォレット",
      "insurance": "保険"
    },
    "paymentSource": {
      "patient": "患者",
      "insurance": "保険",
      "thirdParty": "第三者"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "患者 ID は必須です",
      "encounterIdRequired": "受診 ID は必須です",
      "payerIdRequired": "支払者 ID は必須です",
      "chargeCodeRequired": "請求コードは必須です",
      "unitPriceRequired": "単価は必須です",
      "amountRequired": "金額は必須です",
      "amountPositive": "金額はゼロより大きくする必要があります",
      "chargeSelectionRequired": "少なくとも 1 件の請求を選択してください"
    }
  },
  "pages": {
    "statements": {
      "title": "請求明細書",
      "labels": {
        "dashboard": "ダッシュボード",
        "patient": "患者",
        "from": "開始",
        "to": "終了",
        "batchGenerate": "一括生成",
        "previewStatement": "明細書プレビュー",
        "generatePrint": "生成して印刷",
        "generateEmail": "生成してメール送信",
        "printEmail": "印刷とメール",
        "print": "印刷",
        "email": "メール"
      },
      "placeholders": {
        "searchPatient": "氏名または MRN で検索..."
      },
      "aria": {
        "periodFrom": "明細書期間の開始",
        "periodTo": "明細書期間の終了"
      },
      "table": {
        "header": {
          "statementHistory": "明細書履歴",
          "patient": "患者",
          "mrn": "MRN",
          "date": "日付",
          "amount": "金額",
          "delivery": "送付方法",
          "status": "ステータス"
        },
        "preview": {
          "modal": "明細書プレビュー",
          "patientStatement": "患者明細書",
          "patient": "患者:",
          "mrn": "MRN:",
          "statementDate": "明細書日付:",
          "period": "期間:",
          "lineItemHeader": {
            "date": "日付",
            "description": "説明",
            "charges": "請求",
            "payments": "支払",
            "balance": "残高"
          },
          "openingBalance": "期首残高",
          "totals": "合計",
          "amountDue": "請求金額"
        }
      },
      "states": {
        "generating": "生成中...",
        "loading": "プレビューを生成中...",
        "noPatients": "患者が見つかりません",
        "noStatementData": "明細書データがありません",
        "loadingHistory": "履歴を読み込み中...",
        "noStatementsGenerated": "まだ明細書が生成されていません",
        "selectedPatientId": "選択された患者 ID:{{id}}"
      },
      "toast": {
        "generated": "明細書を生成しました",
        "generatedError": "明細書の生成に失敗しました",
        "batchStarted": "一括生成を開始しました:{{count}} 件の明細書をキューに追加しました",
        "batchError": "一括生成の開始に失敗しました"
      }
    },
    "claims": {
      "title": "請求管理",
      "labels": {
        "dashboard": "ダッシュボード",
        "createClaim": "請求を作成",
        "filters": "フィルター",
        "submit": "提出",
        "appeal": "不服申立",
        "denialReason": "却下理由",
        "expandHint": "専用の請求ページで明細を表示するには請求を展開してください。",
        "cancel": "キャンセル"
      },
      "filter": {
        "allStatuses": "すべてのステータス"
      },
      "placeholders": {
        "filterPayer": "支払者で絞り込み..."
      },
      "aria": {
        "claimDateFrom": "請求日（開始）",
        "claimDateTo": "請求日（終了）"
      },
      "table": {
        "header": {
          "claimNumber": "請求番号",
          "patient": "患者",
          "payer": "支払者",
          "total": "合計",
          "status": "ステータス",
          "submitted": "提出済み",
          "actions": "操作"
        }
      },
      "modal": {
        "createClaim": "請求項目から請求を作成",
        "patientId": "患者 ID *",
        "payerId": "支払者 ID *",
        "selectCharges": "請求項目を選択（{{selected}} 件選択中）",
        "noBilledCharges": "この患者に未請求の項目はありません"
      },
      "states": {
        "loading": "請求を読み込み中...",
        "noClaims": "請求が見つかりません",
        "creating": "作成中..."
      },
      "toast": {
        "created": "請求を作成しました",
        "createdError": "請求の作成に失敗しました",
        "submitted": "請求を提出しました",
        "submittedError": "請求の提出に失敗しました",
        "resubmitted": "不服申立のため請求を再提出しました",
        "resubmittedError": "請求の再提出に失敗しました",
        "patientPayerRequired": "患者と支払者は必須です",
        "chargeRequired": "少なくとも 1 件の請求項目を選択してください"
      }
    },
    "charges": {
      "title": "請求項目管理",
      "labels": {
        "dashboard": "ダッシュボード",
        "newCharge": "新規請求項目",
        "totalChargesPeriod": "請求項目合計（期間）",
        "filters": "フィルター",
        "cancel": "キャンセル"
      },
      "filter": {
        "allStatuses": "すべてのステータス"
      },
      "placeholders": {
        "filterPatient": "患者で絞り込み..."
      },
      "aria": {
        "serviceDateFrom": "診療日（開始）",
        "serviceDateTo": "診療日（終了）"
      },
      "table": {
        "header": {
          "date": "日付",
          "patient": "患者",
          "encounter": "受診",
          "code": "コード",
          "description": "内容",
          "qty": "数量",
          "unitPrice": "単価",
          "total": "合計",
          "status": "ステータス",
          "actions": "操作"
        }
      },
      "actions": {
        "void": "取消"
      },
      "modal": {
        "voidCharge": "請求項目を取消",
        "voidChargeConfirm": "請求項目 {{code}} - {{description}}（{{amount}}）を取り消しますか？",
        "reason": "理由 *",
        "reasonPlaceholder": "取消の理由を入力してください..."
      },
      "states": {
        "loading": "請求項目を読み込み中...",
        "noCharges": "この期間の請求項目が見つかりません",
        "voiding": "取消中..."
      },
      "toast": {
        "voided": "請求項目を取り消しました",
        "voidedError": "請求項目の取消に失敗しました",
        "reasonRequired": "理由は必須です"
      }
    },
    "payments": {
      "title": "支払い計上",
      "labels": {
        "dashboard": "ダッシュボード",
        "uploadEraEob": "ERA/EOB をアップロード",
        "postPayment": "支払いを計上",
        "totalPaymentsPeriod": "支払い合計（期間）",
        "filters": "フィルター",
        "cancel": "キャンセル"
      },
      "placeholders": {
        "filterPatient": "患者で絞り込み..."
      },
      "aria": {
        "paymentDateFrom": "支払日（開始）",
        "paymentDateTo": "支払日（終了）"
      },
      "table": {
        "header": {
          "date": "日付",
          "patient": "患者",
          "claimNumber": "請求番号",
          "amount": "金額",
          "method": "方法",
          "reference": "参照",
          "postedBy": "計上者"
        }
      },
      "modal": {
        "postPayment": "支払いを計上",
        "patientId": "患者 ID *",
        "claimId": "請求 ID（任意）",
        "claimIdHint": "未適用の支払いの場合は空欄にしてください",
        "amount": "金額 *",
        "method": "方法 *",
        "referenceNumber": "参照番号",
        "referenceHint": "小切手番号、取引 ID など",
        "notes": "メモ"
      },
      "states": {
        "loading": "支払いを読み込み中...",
        "noPayments": "この期間の支払いが見つかりません",
        "posting": "計上中..."
      },
      "toast": {
        "posted": "支払いを計上しました",
        "postedError": "支払いの計上に失敗しました",
        "patientAmountRequired": "患者と金額は必須です",
        "validAmount": "有効な金額を入力してください",
        "eraEobSoon": "ERA/EOB アップロードは近日公開予定です"
      }
    },
    "chargeForm": {
      "title": "請求項目を作成",
      "labels": {
        "patientId": "患者ID *",
        "encounterId": "受診ID *",
        "chargeCode": "請求項目コード *",
        "description": "内容",
        "cptCode": "CPTコード",
        "quantity": "数量 *",
        "unitPrice": "単価 *"
      },
      "placeholders": {
        "chargeCode": "請求項目マスタを検索...",
        "cptCode": "CPT手技コードを検索..."
      },
      "buttons": {
        "cancel": "キャンセル",
        "create": "請求項目を作成"
      },
      "toast": {
        "created": "請求項目を作成しました",
        "createdError": "請求項目の作成に失敗しました"
      }
    },
    "claimForm": {
      "title": "請求を作成",
      "labels": {
        "patientId": "患者 ID *",
        "encounterId": "受診ID *",
        "payerId": "支払者 ID *",
        "claimType": "請求タイプ *",
        "diagnosisCodes": "診断コード",
        "selectCharges": "請求項目を選択（{{selected}} 件選択中）",
        "notes": "メモ"
      },
      "placeholders": {
        "diagnosisCodes": "カンマ区切りの ICD-10 コード（例: J06.9, R05）"
      },
      "buttons": {
        "cancel": "キャンセル",
        "create": "請求を作成"
      },
      "toast": {
        "created": "請求を作成しました",
        "createdError": "請求の作成に失敗しました"
      }
    },
    "paymentForm": {
      "title": "支払いを計上",
      "labels": {
        "patientId": "患者 ID *",
        "claimId": "請求 ID",
        "amount": "金額 *",
        "method": "支払い方法 *",
        "source": "支払元",
        "referenceNumber": "参照番号",
        "notes": "メモ"
      },
      "placeholders": {
        "claimId": "任意 — 請求にリンク",
        "reference": "取引番号または小切手の参照"
      },
      "buttons": {
        "cancel": "キャンセル",
        "post": "支払いを計上"
      },
      "toast": {
        "recorded": "支払いを記録しました",
        "recordedError": "支払いの記録に失敗しました"
      }
    },
    "denials": {
      "title": "拒否管理",
      "subtitle": "請求の拒否を追跡・管理します",
      "placeholders": {
        "search": "請求を検索..."
      },
      "filter": {
        "all": "すべて"
      },
      "checkbox": {
        "assignedToMe": "自分の担当"
      },
      "table": {
        "header": {
          "claimNumber": "請求番号",
          "patient": "患者",
          "denialCode": "拒否コード",
          "denialReason": "拒否理由",
          "amount": "金額",
          "daysRemaining": "残り日数",
          "status": "ステータス",
          "assignedTo": "担当者",
          "actions": "操作"
        }
      },
      "actions": {
        "review": "レビュー",
        "appeal": "不服申立て",
        "writeOff": "償却",
        "cancel": "キャンセル"
      },
      "modal": {
        "appealReason": "不服申立て理由",
        "appealPlaceholder": "不服申立ての理由を記入してください...",
        "submitAppeal": "不服申立てを送信",
        "writeOffTitle": "拒否を償却",
        "writeOffConfirm": "請求 {{claimNumber}} を {{amount}} で償却してもよろしいですか？この操作は取り消せません。",
        "writeOffButton": "償却"
      },
      "states": {
        "loading": "拒否を読み込み中...",
        "noDenials": "拒否が見つかりません",
        "submitting": "送信中..."
      },
      "toast": {
        "updateError": "拒否ステータスの更新に失敗しました",
        "movedToReview": "請求 {{claimNumber}} をレビューに移動しました",
        "appealSubmitted": "不服申立てを送信しました",
        "writtenOff": "請求 {{claimNumber}} を償却しました"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
